<script setup lang="ts">
    import { ref } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import { useSuccessDialog } from '@/js/stores/success-dialog';
    import SettingsPageLayout from '@/js/components/settings/SettingsPageLayout.vue';
    import EchoInfoBox from '@/js/components/EchoInfoBox.vue';
    import EchoButton from '@/js/components/EchoButton.vue';
    import BackfillAnalysisReceivedAtJobsTable from '../components/BackfillAnalysisReceivedAtJobsTable.vue';
    import { useMutationTriggerBackfillAnalysisReceivedAt } from '@/js/services/api/backOffice/backOfficeQueries';

    const successDialogStore = useSuccessDialog();
    const { mutateAsync: triggerMutation, isPending } =
        useMutationTriggerBackfillAnalysisReceivedAt();

    const jobsTable = ref<InstanceType<typeof BackfillAnalysisReceivedAtJobsTable> | null>(null);

    const run = async () => {
        const { jobIds } = await triggerMutation();

        successDialogStore.openDialog({
            message: __('back-office-backfill-analysis-received-at-run-success', {
                count: String(jobIds.length),
            }),
        });
        jobsTable.value?.refetch();
    };
</script>
<template>
    <SettingsPageLayout>
        <template #header>
            <h1 class="heading-lg-light">
                {{ __('back-office-backfill-analysis-received-at') }}
            </h1>
        </template>
        <template #content>
            <EchoInfoBox class="mb-6 max-w-2xl">
                {{ __('back-office-backfill-analysis-received-at-description') }}
            </EchoInfoBox>

            <EchoButton variant="primary" :loading="isPending" @click="run">
                {{ __('back-office-backfill-analysis-received-at-run') }}
            </EchoButton>

            <BackfillAnalysisReceivedAtJobsTable ref="jobsTable" class="mt-10" />
        </template>
    </SettingsPageLayout>
</template>
